import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { SALARYPROCESS_BANK_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";
import { useNavigate } from "react-router-dom";
import { ChevronLeftIcon } from "lucide-react";

const SalaryProcessBank = () => {

    const [salaryProcessBankData, setSalaryProcessBankData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
    let navigate = useNavigate()
    const salaryProcessBankColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "bank_name",
            Header: "Bank Name",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ifsc_code",
            Header: "IFSC Code",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "Account_no",
            Header: "Account No",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "take_home",
            Header: "Take Home",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <div className="p-4 dark:bg-gray-900 rounded-lg dark:shadow-md font-sans">
            <div className="flex justify-between items-center mb-4">
                <span className=" flex gap-2 items-center">
                    <ChevronLeftIcon onClick={() => { navigate('/reports') }} className=" cursor-pointer" />
                    <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
                        Salary Process Bank Report ({totalRecords})
                    </h1>
                </span>
            </div>

            <Reactable
                columns={salaryProcessBankColumns}
                data={salaryProcessBankData}
                setData={setSalaryProcessBankData}
                setTotalCount={setTotalRecords}
                url={SALARYPROCESS_BANK_REPORTS}
                serverSide={true}
                tableHeight="calc(100vh - 310px)"
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </div >
    );
}

export default SalaryProcessBank;